import styled from 'styled-components'

export const Button = styled.button`
    background: var(--brand-primary);
    display: flex;
    align-items: center;
    flex-direction: row;

    padding: 6px 20px;
    border: 0px;
    border-radius: 2.5px;

    color: var(--white);
    font-size: 14px;
    font-weight: 600;

    &:disabled {
        opacity: .7;
    }

    > span {
        margin-left: 8px;
    }
`

export const OutlineButton = styled(Button)`
    border: 0px;
    background: transparent;

    font-size: 12px;
    color: var(--brand-primary);

    padding-left: 0px;
    padding-right: 14px;
`